<template>
  <Dialog v-model:visible="visible" modal header="Auto Refresh Paused" :closable="false">
    <div class="flex flex-col items-center">
      <p class="mb-4">Auto refresh has been paused.<br>
        Please refresh the page to re-enable auto refresh.</p>
      <Button severity="primary" label="Refresh Page" @click="refreshPage" />
    </div>
  </Dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const props = defineProps({
  show: Boolean
});
const emit = defineEmits(['update:show']);

const visible = ref(props.show);

watch(() => props.show, (val) => {
  visible.value = val;
});

function refreshPage() {
  window.location.reload();
}
</script>
